<template>
    <div class="billing-container">
        <!-- 搜索表单 -->
        <div class="search-form">
            <el-form :inline="true" :model="searchForm">
                <el-form-item label="公司名称">
                    <el-select v-model="searchForm.companyName" placeholder="请选择" clearable>
                        <el-option v-for="item in companyList" :key="item.deptId" :label="item.deptName"
                            :value="item.deptId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用车单位">
                    <el-input v-model="searchForm.usageUnit" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="发起时间">
                    <el-date-picker v-model="startDateRange" type="daterange" range-separator="至"
                        start-placeholder="年月日" end-placeholder="年月日" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="发起人">
                    <el-input v-model="searchForm.contactName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="签约时间">
                    <el-date-picker v-model="signDateRange" type="daterange" range-separator="至" start-placeholder="年月日"
                        end-placeholder="年月日" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="签约状态">
                    <el-select v-model="searchForm.isSign" placeholder="请选择" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option label="已签约" value="1"></el-option>
                        <el-option label="未签约" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="司机">
                    <el-input v-model="searchForm.driver" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-input v-model="searchForm.licensePlate" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="showBillingDialog">发起对账单</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 数据表格 -->
        <el-table :data="tableData" style="width: 100%" border max-height="600" :header-cell-style="headerCellStyle"
            :cell-style="cellStyle" v-loading="loading">
            <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="companyName" label="公司名称" min-width="150" align="center"></el-table-column>
            <el-table-column prop="usageUnit" label="用车单位" min-width="120" align="center"></el-table-column>
            <el-table-column prop="useDate" label="用车日期" min-width="120" align="center"></el-table-column>
            <el-table-column prop="returnDate" label="返车日期" min-width="120" align="center"></el-table-column>
            <el-table-column prop="teamItinerary" label="团队行程" min-width="220" align="center"></el-table-column>
            <el-table-column prop="driver" label="司机" min-width="100" align="center"></el-table-column>
            <el-table-column prop="licensePlate" label="车牌号" min-width="100" align="center"></el-table-column>
            <el-table-column prop="seats" label="座位数" width="80" align="center"></el-table-column>
            <el-table-column prop="kilometers" label="行驶公里" width="100" align="center"></el-table-column>
            <el-table-column prop="rentalDays" label="租用天数" width="80" align="center"></el-table-column>
            <el-table-column prop="unitPrice" label="车辆单价" width="80" align="center"></el-table-column>
            <el-table-column prop="amount" label="应收金额" width="80" align="center"></el-table-column>
            <el-table-column prop="contactName" label="发起人" width="100" align="center"></el-table-column>
            <el-table-column prop="createTime" label="发起时间" width="120" align="center"></el-table-column>
            <el-table-column prop="signTime" label="签约时间" width="120" align="center"></el-table-column>
            <el-table-column label="附件" width="100" align="center">
                <template slot-scope="scope">
                    <el-link 
                        :type="scope.row.accessory ? 'primary' : 'info'" 
                        :disabled="!scope.row.accessory"
                        @click="handleViewAttachment(scope.row)">
                        {{ scope.row.accessory ? '下载附件' : '无附件' }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="280" align="center" fixed="right">
                <template slot-scope="scope">
                    <!-- <el-tooltip :content="scope.row.state === 1 ? '合同已作废' : (scope.row.isSign === 1 ? '已签约不能分享' : '')"
                        placement="top" :disabled="scope.row.state !== 1 && scope.row.isSign !== 1"> -->
                        <el-button size="small" type="warning" @click="handleShare(scope.row)"
                           >分享</el-button>
                    <!-- </el-tooltip> -->
                    <el-tooltip :content="scope.row.state === 1 ? '合同已作废' : ''" placement="top"
                        :disabled="scope.row.state !== 1">
                        <el-button size="small" type="primary" @click="handleView(scope.row)"
                            :disabled="scope.row.state === 1">查看</el-button>
                    </el-tooltip>
                    <el-tooltip :content="scope.row.state === 1 ? '合同已作废' : ''" placement="top"
                        :disabled="scope.row.state !== 1">
                        <el-button size="small" type="danger" @click="handleVoid(scope.row)"
                            :disabled="scope.row.state === 1">作废</el-button>
                    </el-tooltip>
                    <el-tooltip :content="scope.row.state == 1 ? '合同已作废' : (scope.row.isSign == 0 ? '未签约不能下载' : '')"
                        placement="top" :disabled="scope.row.state !== 1 && scope.row.isSign !== 0">
                        <el-button size="small" type="success" @click="handleDownload(scope.row)"
                            :disabled="scope.row.state === 1 || scope.row.isSign === 0">下载</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="searchForm.pageNum"
            :page-size="searchForm.pageSize" layout="total, prev, pager, next, jumper" :total="total" background
            style="margin-top: 20px; text-align: right;">
        </el-pagination>

        <!-- 二维码弹窗 -->
        <el-dialog :visible.sync="QRVisible" width="30%" :before-close="QRClose" title="提示" center>
            <div style="width: 100%; height: 200px; display: flex; align-items: center; justify-content: center;">
                <div ref="qrcode" style="width: 200px; height: 200px" v-if="QRVisible"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <span>将二维码截图分享至微信好友，好友识别/扫码二维码查看对账单</span>
            </span>
            <div v-if="currentShareRow && currentShareRow.isSign == 1" style="text-align:center;color:#67C23A;font-weight:bold;margin-top:10px;">已签约</div>
        </el-dialog>

        <!-- 账单详情弹窗 -->
        <el-dialog title="账单详情" :visible.sync="detailDialogVisible" width="60%">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="公司名称">{{ currentBill.companyName }}</el-descriptions-item>
                <el-descriptions-item label="用车单位">{{ currentBill.usageUnit }}</el-descriptions-item>
                <el-descriptions-item label="用车时间">{{ currentBill.useDate }}</el-descriptions-item>
                <el-descriptions-item label="返车时间">{{ currentBill.returnDate }}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{ currentBill.contactName }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{ currentBill.contactPhone }}</el-descriptions-item>
                <el-descriptions-item label="我方联系人" v-if="currentBill.myContactName">{{ currentBill.myContactName
                    }}</el-descriptions-item>
                <el-descriptions-item label="我方联系电话" v-if="currentBill.myContactPhone">{{ currentBill.myContactPhone
                    }}</el-descriptions-item>
                <el-descriptions-item label="司机">{{ currentBill.driver }}</el-descriptions-item>
                <el-descriptions-item label="车牌号">{{ currentBill.licensePlate }}</el-descriptions-item>
                <el-descriptions-item label="座位数">{{ currentBill.seats }}</el-descriptions-item>
                <el-descriptions-item label="行驶公里">{{ currentBill.kilometers }}</el-descriptions-item>
                <el-descriptions-item label="租用天数">{{ currentBill.rentalDays }}</el-descriptions-item>
                <el-descriptions-item label="车辆单价">{{ currentBill.unitPrice || '-' }}</el-descriptions-item>
                <el-descriptions-item label="应收金额">{{ currentBill.amount }}</el-descriptions-item>
                <el-descriptions-item label="签约状态">{{ currentBill.isSign === 1 ? '已签约' : '未签约' }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ currentBill.createTime }}</el-descriptions-item>
                <el-descriptions-item label="团队行程" :span="2">{{ currentBill.teamItinerary }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关 闭</el-button>
                <el-tooltip :content="currentBill.isSign === 0 ? '未签约不能下载' : ''" placement="top"
                    :disabled="currentBill.isSign !== 0">
                </el-tooltip>
            </span>
        </el-dialog>

        <!-- 发起对账单弹窗 -->
        <el-dialog title="发起对账单" :visible.sync="billingDialogVisible" width="50%" :before-close="handleCloseDialog">
            <el-tabs v-model="activeTab">
                <el-tab-pane label="手动填写" name="manual">
                    <el-form :model="billingForm" label-width="100px" label-position="right" :rules="rules"
                        ref="billingForm">
                        <el-form-item label="公司名称" prop="companyName">
                            <el-select v-model="billingForm.companyName" placeholder="请选择" style="width: 100%">
                                <el-option v-for="item in companyList" :key="item.deptId" :label="item.deptName"
                                    :value="item.deptId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用车单位" prop="usageUnit">
                            <el-input v-model="billingForm.usageUnit" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="contactPhone">
                            <el-input v-model="billingForm.contactPhone" placeholder="请输入"
                                oninput="value=value.replace(/[^\d]/g,'')" maxlength="11">
                                <template slot="append">
                                    <i class="el-icon-warning-outline"></i> 此手机号同时用于接受签约短信通知
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系人" prop="contactName">
                            <el-input v-model="billingForm.contactName" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="用车时间" prop="useDate">
                            <el-date-picker v-model="billingForm.useDate" type="date" placeholder="年月日"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="返车时间" prop="returnDate">
                            <el-date-picker v-model="billingForm.returnDate" type="date" placeholder="年月日"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="租用天数" prop="rentalDays">
                            <el-input v-model.number="billingForm.rentalDays" placeholder="请输入"
                                type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="团队行程" prop="teamItinerary">
                            <el-input v-model="billingForm.teamItinerary" type="textarea" :rows="3"
                                placeholder="请输入团队行程"></el-input>
                        </el-form-item>
                        <el-form-item label="司机" prop="driver">
                            <el-input v-model="billingForm.driver" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="车牌号" prop="licensePlate">
                            <el-input v-model="billingForm.licensePlate" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="座位数" prop="seats">
                            <el-input v-model.number="billingForm.seats" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="行驶公里数" prop="kilometers">
                            <el-input v-model.number="billingForm.kilometers" placeholder="请输入"
                                type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="车辆单价" prop="unitPrice">
                            <el-input v-model.number="billingForm.unitPrice" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="应收金额" prop="amount">
                            <el-input v-model.number="billingForm.amount" placeholder="请输入" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="附件">
                            <el-upload class="upload-demo" :action="uploadUrl" :on-success="handleAvatarSuccess"
                                :on-exceed="handleExceed" :before-upload="beforeUpload" multiple :limit="1"
                                accept=".xls">
                                <el-button size="small" type="primary">上传文件</el-button>
                                <div slot="tip" class="el-upload__tip">只支持.xls格式Excel文件，且不超过2Mb</div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="文件上传" name="upload">
                    <el-form :model="uploadForm" label-width="120px" label-position="right" :rules="uploadRules"
                        ref="uploadForm">
                        <el-form-item label="公司名称" prop="companyName">
                            <el-select v-model="uploadForm.companyName" placeholder="请选择" style="width: 100%">
                                <el-option v-for="item in companyList" :key="item.deptId" :label="item.deptName"
                                    :value="item.deptId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系人" prop="contactPerson">
                            <el-input v-model="uploadForm.contactPerson" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="contactMethod">
                            <el-input v-model="uploadForm.contactMethod" placeholder="请输入"
                                oninput="value=value.replace(/[^\d]/g,'')" maxlength="11">
                                <template slot="append">
                                    <i class="el-icon-warning-outline"></i> 此手机号同时用于接受签约短信通知
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="对账单数据源（表格）上传" prop="exceUrl">
                            <el-upload class="upload-excel" drag :action="uploadUrl" :on-success="handleAvatarSuccess"
                                :on-exceed="handleExceed" :before-upload="beforeUpload" multiple :limit="1"
                                accept=".xls">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">只能上传.xls格式Excel文件，且不超过2Mb</div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="submitBillingForm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getBillList, addBill, addBillBatch, getBillById, userDeptById, updateBill } from '@/api'
import Cokie from 'js-cookie'
import axios from "axios";
import QRCode from "qrcodejs2";
import { API_BASE_URL, UPLOAD_URL, CONTRACT_URLS } from '../utils/api-config'

export default {
    name: 'Billing',
    data() {
        return {
            apiBaseUrl: API_BASE_URL,
            uploadUrl: UPLOAD_URL,
            companyList: [],//公司列表
            loading: false,//加载中
            total: 0,//总条数
            startDateRange: [],
            signDateRange: [],
            //搜索表单
            searchForm: {
                pageNum: 1,//当前页
                pageSize: 10,//每页条数
                companyName: null,
                usageUnit: '',
                initiator: '',
                status: '',
                driver: '',
                licensePlate: ''
            },
            tableData: [],//账单列表
            billingDialogVisible: false,//对账单弹窗
            activeTab: 'manual',//当前tab
            //手动填写表单
            billingForm: {
                companyName: null,
                usageUnit: '',
                contactPhone: '',
                contactName: '',
                useDate: '',
                returnDate: '',
                rentalDays: 0,
                teamItinerary: '',
                driver: '',
                licensePlate: '',
                seats: 0,
                kilometers: 0,
                unitPrice: 0,
                amount: 0,
            },
            //表单验证规则
            rules: {
                companyName: [{ required: true, message: '请选择公司名称', trigger: 'change' }],
                usageUnit: [{ required: true, message: '请输入用车单位', trigger: 'blur' }],
                contactPhone: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '联系方式只能输入数字', trigger: 'blur' }
                ],
                contactName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                useDate: [{ required: true, message: '请选择用车时间', trigger: 'change' }],
                returnDate: [{ required: true, message: '请选择返车时间', trigger: 'change' }],
                rentalDays: [{ required: true, message: '请输入租用天数', trigger: 'blur' }],
                teamItinerary: [{ required: true, message: '请输入团队行程', trigger: 'blur' }],
                driver: [{ required: true, message: '请输入司机', trigger: 'blur' }],
                licensePlate: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
                seats: [{ required: true, message: '请输入座位数', trigger: 'blur' }],
                kilometers: [{ required: true, message: '请输入行驶公里数', trigger: 'blur' }],
                amount: [{ required: true, message: '请输入应收金额', trigger: 'blur' }]
            },
            //文件上传表单
            uploadForm: {
                companyName: null,
                contactPerson: '',
                contactMethod: '',
                exceUrl: ''
            },
            //上传表单验证规则
            uploadRules: {
                companyName: [{ required: true, message: '请选择公司名称', trigger: 'change' }],
                contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                contactMethod: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { pattern: /^\d+$/, message: '联系方式只能输入数字', trigger: 'blur' }
                ],
                exceUrl: [{ required: true, message: '请上传Excel文件', trigger: 'change' }]
            },
            fileList: [],//文件列表
            excelFile: null,//Excel文件
            //账单详情弹窗
            detailDialogVisible: false,
            //当前账单
            currentBill: {},
            //二维码弹窗
            QRVisible: false,
            qrcode: null,
        };
    },
    mounted() {
        this.apiGetBillList();
        this.apiGetCompanyList();
    },
    methods: {
        //获取公司列表
        apiGetCompanyList() {
            userDeptById().then(res => {
                if (res.data.code == 200) {
                    this.companyList = res.data.data;

                } else {
                    this.$message.error(res.data.msg);
                }

            })
        },
        // 获取账单列表
        apiGetBillList() {
            const params = { ...this.searchForm };
            if (this.startDateRange) {
                if (this.startDateRange.length > 0) {
                    params.startTime = this.startDateRange[0];
                    params.endTime = this.startDateRange[1];
                } else {
                    params.startTime = '';
                    params.endTime = '';
                }
            }

            if (this.signDateRange) {
                if (this.signDateRange.length > 0) {
                params.signStartTime = this.signDateRange[0];
                params.signEndTime = this.signDateRange[1];
            } else {
                params.signStartTime = '';
                    params.signEndTime = '';
                }
            }
            if (params.companyName) {
                // 根据选中的deptId查找对应的公司名称
                const company = this.companyList.find(item => item.deptId == params.companyName);
                if (company) {
                    params.companyName = company.deptName;
                    params.deptId = company.deptId;
                }
            }
            getBillList(params).then(res => {
                if (res.data.code == 200) {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    console.log('--------------------------------');
                    console.log(this.tableData);
                    console.log('--------------------------------');
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 表头样式
        headerCellStyle() {
            return "background-color: #e8e8e8; text-align: center; color: black;";
        },
        // 单元格样式
        cellStyle() {
            return "text-align: center;";
        },
        // 搜索
        handleSearch() {
            this.searchForm.pageNum = 1;
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.apiGetBillList();
        },
        // 分页变化
        handleCurrentChange(val) {
            this.searchForm.pageNum = val;
            this.apiGetBillList();
        },
        // 打开对账单弹窗
        showBillingDialog() {
            this.billingDialogVisible = true;
        },
        // 关闭对账单弹窗
        handleCloseDialog() {
            this.billingDialogVisible = false;
            this.activeTab = 'manual';
            // 重置表单
            this.billingForm = {
                companyName: null,
                usageUnit: '',
                contactPhone: '',
                contactName: '',
                useDate: '',
                returnDate: '',
                rentalDays: 0,
                teamItinerary: '',
                driver: '',
                licensePlate: '',
                seats: 0,
                kilometers: 0,
                unitPrice: 0,
                amount: 0
            };
            this.uploadForm = {
                companyName: null,
                contactPerson: '',
                contactMethod: '',
                exceUrl: ''
            };
            this.fileList = [];
            this.excelFile = null;
        },
        // 提交对账单表单
        submitBillingForm() {
            if (this.activeTab === 'manual') {
                this.$refs.billingForm.validate((valid) => {
                    if (valid) {
                        this.apiAddBill();
                        this.$message.success('手动填写对账单已提交');
                        this.handleCloseDialog();
                    } else {
                        this.$message.error('请填写所有必填项');
                        return false;
                    }
                });
            } else {
                this.$refs.uploadForm.validate((valid) => {
                    if (valid) {
                        this.apiBatchAddBill();
                        this.$message.success('Excel对账单已上传');
                        this.handleCloseDialog();
                    } else {
                        this.$message.error('请填写必填项并上传Excel文件');
                        return false;
                    }
                });
            }
        },
        // 单个新增
        apiAddBill() {
            const params = { ...this.billingForm };
            // 设置我方联系信息
            params.myContactPhone = Cokie.get('phonenumber');
            params.myContactName = Cokie.get('user');
            // 如果有选择公司，根据deptId获取公司名称
            if (params.companyName) {
                const company = this.companyList.find(item => item.deptId === params.companyName);
                if (company) {
                    params.companyName = company.deptName;
                    params.deptId = company.deptId;
                }
            }

            addBill(params).then(res => {
                if (res.data.code == 200) {
                    this.billingDialogVisible = false;
                    this.$message.success(res.data.msg);
                    this.apiGetBillList();
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 批量新增
        apiBatchAddBill() {
            const params = {
                companyName: this.uploadForm.companyName,
                contactName: this.uploadForm.contactPerson,
                contactPhone: this.uploadForm.contactMethod,
                exceUrl: this.uploadForm.exceUrl,
                myContactPhone: Cokie.get('phonenumber'),
                myContactName: Cokie.get('user')
            };

            // 如果有选择公司，根据deptId获取公司名称
            if (this.uploadForm.companyName) {
                const company = this.companyList.find(item => item.deptId === this.uploadForm.companyName);
                if (company) {
                    params.companyName = company.deptName;
                    params.deptId = company.deptId;
                }
            }

            addBillBatch(params).then(res => {
                if (res.data.code == 200) {
                    this.apiGetBillList();
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 导出对账单
        exportBilling() {
            this.$message.success('对账单已发起');
        },
        // 分享
        handleShare(row) {
            this.currentShareRow = row;
            this.QRVisible = true;
            setTimeout(() => {
                this.generateQRCode(row);
            }, 100);
        },
        // 生成二维码
        generateQRCode(row) {
            if (this.qrcode) {
                this.qrcode.clear();
                this.$refs.qrcode.innerHTML = '';
            }
            this.qrcode = new QRCode(this.$refs.qrcode, {
                text: `https://permanentpicture.hellouxing.com/Billing?id=${row.parentId}`,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
        },
        // 关闭二维码弹窗
        QRClose() {
            this.QRVisible = false;
            if (this.qrcode) {
                this.qrcode.clear();
                this.$refs.qrcode.innerHTML = '';
            }
        },
        // 查看详情
        handleView(row) {
            getBillById(row.id).then(res => {
                if (res.data.code == 200) {
                    this.currentBill = res.data.data;
                    this.detailDialogVisible = true;
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 作废合同
        handleVoid(row) {
            this.$confirm(`确认要作废"${row.usageUnit}"的合同吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateBill({
                    id: row.id,
                    state: 1,
                    parentId: row.parentId
                }).then(res => {
                    this.$message.success(res.data.msg);
                    this.apiGetBillList();
                })
            }).catch(() => {
                ;
            });
        },
        // 下载合同
        handleDownload(row) {
            this.$message.success(`${row.usageUnit}合同下载中...`);
            const data = { parentId: row.parentId };
            axios.defaults.headers.common["Authorization"] = `Bearer ${Cokie.get(
                "token"
            )} `;
            axios({
                method: "get",
                url: CONTRACT_URLS.GET_BILL_PDF,
                params: data,
                responseType: "blob",
            })
                .then((res) => {
                    console.log(res.data);
                    const blob = new Blob([res.data], { type: "application/pdf" });
                    let objectURL = URL.createObjectURL(blob);
                    let downEle = document.createElement("a");
                    downEle.href = objectURL;
                    const date = new Date();
                    const formattedDate = this.formatDate(date);
                    downEle.setAttribute("download", "对账单" + formattedDate);
                    document.body.appendChild(downEle);
                    downEle.click();

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 上传成功
        handleAvatarSuccess(res, file) {
            this.$message.success('上传成功');
            if (res.code == 10000) {
                if (this.activeTab === 'manual') {
                    this.billingForm.accessory = res.data;
                } else {
                    this.uploadForm.exceUrl = res.data;
                }
            }
        },
        // 上传超过限制
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，请删除后继续。`);
        },
        // 上传预览
        handlePreview(file) {
            console.log(file);
        },

        // 上传前验证
        beforeUpload(file) {
            const isExcel = file.type === 'application/vnd.ms-excel';
            const isXlsFile = file.name.toLowerCase().endsWith('.xls');

            if (!isExcel || !isXlsFile) {
                this.$message.error('只能上传.xls格式的Excel文件！');
                return false;
            }

            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('文件大小不能超过 2MB!');
                return false;
            }
            return true;
        },
        // 年月日
        formatDate(date) {
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        },
        
        // 查看附件
        handleViewAttachment(row) {
            if (!row.accessory) return;
            // 直接下载附件
            const fileUrl = row.accessory;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', `附件-${row.id}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },

}
</script>

<style lang="scss" scoped>
.billing-container {
    padding: 20px;
    background-color: #fff;

    .search-form {
        margin-bottom: 10px;
    }

    .el-pagination {
        margin-top: 20px;
    }
}

.upload-excel {
    width: 100%;

    .el-upload {
        width: 100%;

        .el-upload-dragger {
            width: 100%;
        }
    }
}

.el-upload__tip {
    line-height: 1.2;
    padding-top: 5px;
}
</style>